window.Vapor = require('laravel-vapor');
